module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/notokr-regular.woff
// module id = LwRh
// module chunks = 0